
//const apiurl = "http://api.evolve.de/evolvedemopage/api/backend/";

const apiurl = "https://api.evolvejobs.de/demo/api/backend/";
export default apiurl;